export const defaultScopeId = "v3.projects";
export const LOAD_REQUESTED = "PROJECTS/LOAD_REQUESTED";
export const LOAD_SUCCEEDED = "PROJECTS/LOAD_SUCCEEDED";
export const LOAD_FAILED = "PROJECTS/LOAD_FAILED";


// eslint-disable-next-line complexity, max-statements
export default (
    state = {
        loading: false,
        data: [],
    },
    { type, data }
) => {
    switch(type){
    case LOAD_REQUESTED: {
        return { ...state, loading: true };
    }
    case LOAD_SUCCEEDED: {
        return { ...state, loading: false, data };
    }
    case LOAD_FAILED: {
        return { ...state, loading: false };
    }
    default:
        return state;
    }
};

export const loadProjectsReqested = (data, resolve, reject) => ({ type: LOAD_REQUESTED, data, resolve, reject });
export const loadProjectsSucceeded = data => ({ type: LOAD_SUCCEEDED, data });
export const loadProjectsFailed = data => ({ type: LOAD_FAILED, data });
